import { mString } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import PayOnlineButton from 'components/Payments/payroc/PayOnlineButton';
import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

const Footer = ({
  step,
  amount,
  onClose,
  onRetry,
  status,
  isClosing = false,
  isRetrying = false,
  saveCardOnly = false,
  onRetryFormLoad
}) => {
  const { values } = usePaymentContext();
  const { handlePayment } = usePaymentContextApi();

  const isNewCard = step === 'credit-card';
  const canRetry = !isNewCard && (status === 'error' || status === 'canceled');

  if (status === 'success')
    return (
      <div className="flex items-center gap-3">
        <Button
          text="Close"
          variant="tertiary"
          size="small"
          isLoading={isClosing}
          isDisabled={isClosing}
          onClick={onClose}
        />
        <Button
          text="Acknowledge & continue"
          size="small"
          isLoading={isClosing}
          isDisabled={isClosing}
          onClick={onClose}
        />
      </div>
    );

  return (
    <div className="flex w-full items-center justify-between gap-3">
      <Button
        text={isNewCard ? 'Back' : 'Cancel'}
        variant="tertiary"
        isLoading={isClosing}
        isDisabled={isClosing}
        onClick={onClose}
      />

      {canRetry && (
        <Button
          text="Retry"
          icon="refresh-linear"
          isLoading={isRetrying}
          isDisabled={isRetrying || isClosing}
          onClick={onRetry}
        />
      )}

      {!isNewCard && !saveCardOnly && values.methodDetail && (
        <Button
          text={`Pay ${mString(amount)}`}
          isDisabled={isRetrying || isClosing}
          onClick={() => handlePayment()}
        />
      )}

      {isNewCard &&
        (onRetryFormLoad ? (
          <Button text="Retry" icon="refresh-linear" iconColor="white" onClick={onRetryFormLoad} />
        ) : (
          <PayOnlineButton payrocId="pay-with-new-card" className="justify-end" />
        ))}
    </div>
  );
};

export default Footer;
